import project from "../config/project";

const { API_BASE_URL, API } = project;

class Endpoint {
  //rts
  static vesselTanker() {
    return `${API_BASE_URL}/${API}/v1/rts/vessels`;
  }
  //mp
  static mpTankers(){
    return `${API_BASE_URL}/${API}/v1/mp/tankers`;
  }
  static mpStations(){
    return `${API_BASE_URL}/${API}/v1/mp/stations`;
  }
  static mpVessels(){
    return `${API_BASE_URL}/${API}/v1/mp/vessels`;
  }
  static transferLogs() {
    return `${API_BASE_URL}/${API}/v1/mp/transfer_logs`;
  }
  //Petrol
  static vesselTrips() {
    return `${API_BASE_URL}/${API}/v1/petrol/vessel_trips`;
  }
  static petrolOilTypes() {
    return `${API_BASE_URL}/${API}/v1/petrol/oil_types`;
  }
  static petrolNotifications() {
    return `${API_BASE_URL}/${API}/v1/petrol/event_notifications`;
  }
  static petrolMarkEventNotificationsAsRead() {
    return `${API_BASE_URL}/${API}/v1/petrol/event_notifications/mark_as_read`;
  }
  static petrolMarkAllEventNotificationsAsRead() {
    return `${API_BASE_URL}/${API}/v1/petrol/event_notifications/mark_all_as_read`;
  }
  //<---- User ---->
  static users() {
    return `${API_BASE_URL}/${API}/v1`;
  }
  static usersLogin() {
    return `${API_BASE_URL}/${API}/v1/auth/login`;
  }
  static usersRegister() {
    return `${API_BASE_URL}/${API}/v1/auth/register`;
  }
  //oil-price
  static oilPriceLog() {
    return `${API_BASE_URL}/${API}/v1/oil_price/find_all`;
  }
  static addOilPriceLog() {
    return `${API_BASE_URL}/${API}/v1/oil_price/addPrice`;
  }
  static lastOilPriceLog() {
    return `${API_BASE_URL}/${API}/v1/oil_price/find_one`;
  }
  //price-oil-type
  static addPriceOilTypeLog() {
    return `${API_BASE_URL}/${API}/v1/oil_type/addPrice`;
  }
  static findAllPriceOilTypeLog() {
    return `${API_BASE_URL}/${API}/v1/oil_type/find_all`;
  }
  static findPriceOilTypeLogByOilId() {
    return `${API_BASE_URL}/${API}/v1/oil_type/find_by_oil_id`;
  }
}

export default Endpoint;

export const MP_API = `${API_BASE_URL}/${API}/v1/mp/transfer_logs`;
